import ReactAnimatedWeather from "react-animated-weather";

export default function ForecastDay(props) {
  function convertTemperature(celsius) {
    if (props.unit === "F") {
      return Math.round((celsius * 9) / 5 + 32);
    }

    return Math.round(celsius);
  }

  return (
    <div className="forecast-item">
      <h3>{props.day}</h3>

      <p className="forecast-date">
        {props.date}
      </p>

      <ReactAnimatedWeather
        icon={props.icon}
        color={props.darkMode ? "#b9a8ff" : "#7257d9"}
        size={45}
        animate={true}
      />

      <p className="forecast-description">
        {props.description}
      </p>

      <div className="forecast-details">
        <p>
          <strong>High:</strong>{" "}
          {convertTemperature(props.high)}°{props.unit}
        </p>

        <p>
          <strong>Low:</strong>{" "}
          {convertTemperature(props.low)}°{props.unit}
        </p>

        <p>💨 {props.wind} km/h</p>

        <p>💧 {props.humidity}%</p>
      </div>
    </div>
  );
}